module.exports = {
    LOCAL_SITE_COUNTRIES: ['DE', 'FR', 'IT', 'ES', 'NL'],
    MAIN_SITE_COUNTRIES: ['BR', 'PT'],
    MAIN_SITE_LANGUAGES: ['en'],
    EXCLUDED_CURRENCIES: ['USD']
};
